import { OnboardingLayout } from "@bcc/components/onboarding-layout";
import { ConnectServiceStep } from "@bcc/components/onboarding/connect-service-step";

export function OnboardingPage() {
  return (
    <OnboardingLayout>
      <ConnectServiceStep />
    </OnboardingLayout>
  );
}
